import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, first } from 'rxjs/operators';
import { User } from '../../shared/models/user.interface';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const allowedRoles = route.data['roles'] as Array<'Administrator' | 'Coordinator' | 'Technician'>;

  return authService.currentUser$.pipe(
    first(user => user !== null), // Wait for the first non-null user
    map(user => {
      if (user && allowedRoles && allowedRoles.includes((user as User).role)) {
        return true;
      }
      return router.createUrlTree(['/login']);
    })
  );
};